import React from 'react';
import {
  formErrorTextClassName,
  formHelpTextClassName,
  formLabelClassName,
  formSelectClassName,
} from './formFieldStyles';

interface Option {
  value: string;
  label: string;
}

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  helpText?: string;
  required?: boolean;
  options: ReadonlyArray<Option>;
  placeholder?: string;
}

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ label, error, helpText, required, options, placeholder, className, id, ...props }, ref) => {
    const inputId = id || `select-${Math.random().toString(36).slice(2)}`;

    return (
      <div className="w-full">
        {label && (
          <label htmlFor={inputId} className={`${formLabelClassName} mb-1.5`}>
            {label}
            {required && <span className="ms-1 text-[#A32D2D]">*</span>}
          </label>
        )}

        <select
          ref={ref}
          id={inputId}
          className={`${formSelectClassName} ${error ? 'border-[#A32D2D] focus:border-[#A32D2D] focus:ring-[rgba(163,45,45,0.12)]' : ''} ${className || ''}`}
          aria-invalid={!!error}
          aria-describedby={error ? `${inputId}-error` : helpText ? `${inputId}-help` : undefined}
          {...props}
        >
          {placeholder && <option value="">{placeholder}</option>}
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>

        {error && (
          <p id={`${inputId}-error`} className={formErrorTextClassName}>
            {error}
          </p>
        )}

        {helpText && !error && (
          <p id={`${inputId}-help`} className={formHelpTextClassName}>
            {helpText}
          </p>
        )}
      </div>
    );
  }
);

Select.displayName = 'Select';
